const localHost = hostname => {
    const host = hostname.toLowerCase().replace(/^\[|\]$/g, '');
    if (host === 'localhost' || host.endsWith('.localhost') || host === '::1') return true;
    if (host.includes(':')) return /^(?:f[cd][0-9a-f]{2}:|fe[89ab][0-9a-f]:)/i.test(host);
    const bytes = host.split('.');
    if (bytes.length !== 4 || !bytes.every(byte => /^\d+$/.test(byte) && Number(byte) <= 255)) return false;
    const [first, second] = bytes.map(Number);
    return first === 127 || first === 10 || (first === 192 && second === 168)
        || (first === 172 && second >= 16 && second <= 31) || (first === 169 && second === 254);
};

const baseUrl = (value, origin) => {
    const url = new URL(value, origin);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
        throw new Error('QR Flex base URLs must be HTTP(S) URLs without credentials, queries or fragments.');
    }
    return url.href.replace(/\/+$/, '') + '/';
};

export function resolveEnvironment(location, runtime = {}, build = {}) {
    const environment = localHost(location.hostname) ? 'local' : 'production';
    const settings = {...runtime, ...(runtime[environment] || {})};
    // A stale development .env file must not send live visitors to their own localhost.
    const buildValue = value => value && localHost(new URL(value, location.origin).hostname) === (environment === 'local') ? value : '';
    const appUrl = baseUrl(new URL('.', location.href.split('#')[0]).href, location.origin);
    const knownProduction = /^(www\.)?qr-flex\.com$/i.test(location.hostname);
    const productionRoot = knownProduction ? 'https://qr-flex.com/' : appUrl;
    const developmentServer = environment === 'local' && /^3\d{3}$/.test(String(location.port));
    const localOrigin = new URL(location.origin);
    if (developmentServer) localOrigin.port = '';
    const automaticApi = developmentServer
        ? new URL(settings.localBackendPath || '/QR/q6/qr-flex/backend/', localOrigin.origin).href
        : new URL('backend/', productionRoot).href;
    const apiUrl = baseUrl(settings.apiUrl || buildValue(build.apiUrl) || automaticApi, location.origin);
    const publicUrl = baseUrl(settings.publicUrl || buildValue(build.publicUrl) || apiUrl.replace(/backend\/$/, ''), location.origin);
    return {environment, apiUrl, publicUrl, appUrl: knownProduction ? productionRoot : appUrl};
}
